var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preformAction"},[_c('i',[_vm._v("*")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$it('tip.nz')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }